import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { APP_PATHS } from '../../../constants';

interface GameCard {
  id: number;
  title: string;
  price: string;
  image: string;
}

interface WelcomeSectionProps {
  gameCards: GameCard[];
  version: number; // The active version id
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({ gameCards, version }) => {
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false); // State for "clicked" class
  const positionClasses = [styles.farLeft, styles.left, styles.center, styles.right, styles.farRight];

  // Function to handle the click event on the "Start Earning" button
  const handleClick = () => {
    setClicked(true);
    setTimeout(() => {
      navigate(APP_PATHS.SIGN_UP);
    }, 500);
  };

  return (
    <section className={styles.welcomeSection}>
      <div className={styles.wrapper}>
        <h1 className={styles.heading}>
          {/* Dynamic CTA title, detrmined by the version assigned to user */}
          {(() => {
            switch (version) {
              case 1:
                return (
                  <>
                    <span style={{ color: '#FFB142' }}>Get paid </span>for playing games you love
                  </>
                );
              case 2:
                return (
                  <>
                    <span style={{ color: '#FFB142' }}>Start earning </span>in less than 5 minutes
                  </>
                );
              case 3:
                return (
                  <>
                    Players making<span style={{ color: '#FFB142' }}> tons of cash. </span> Join them
                  </>
                );
              default:
                return (
                  <>
                    <span style={{ color: '#FFB142' }}>Get paid </span>for playing games you love
                  </>
                );
            }
          })()}
        </h1>
        <div
          className={`${styles.exploreRewards} ${clicked ? styles.clicked : ''}`} // Add clicked class conditionally
          onClick={handleClick} // Handle click event
        >
          <h2>Start Earning</h2>
        </div>

        {/* Game Cards Carousel */}
        <div className={styles.gameCardsContainer}>
          {gameCards.map((card, index) => (
            <div key={card.id} className={`${styles.gameCard} ${positionClasses[index] || styles.farRight}`}>
              <img src={card.image} alt={card.title} className={styles.gameImage} decoding="auto" loading='eager'/>
              <div className={styles.gameInfo}>
                <h3 className={styles.gameTitle}>{card.title}</h3>
                <p className={styles.gamePrice}>{card.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
